import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Expedientes from '../components/Expedientes'
import { ExpedientesProvider } from '../providers/ExpedientesProvider'

const ExpedientesPage = ({ object: forced_id }) => {
  const location = useLocation()

  const [expediente, setExpediente] = useState(forced_id)

  useEffect(() => {
    if (location?.state?.expediente) {
      setExpediente(location.state.expediente)
    } else if (location.pathname === '/expedientes' && !location?.state?.expediente) {
      setExpediente(null)
    }
  }, [location])

  return (
    <ExpedientesProvider>
      <Expedientes />
    </ExpedientesProvider>
  )
}

export default ExpedientesPage
